import React, { useEffect, useState } from 'react';
import _ from 'lodash';

import { Row, Col, Divider } from 'antd';

import { BookedForSalesEventSummary, CustomerSummary } from '../../../../api-client';
import { CUSTOMERS_REFINEMENT } from '../../../../utils/constants/refinements-definition';

import './bv-customers-group.scss';

import BVEmpty from '../../../../common/components/BVEmpty/bv-empty';
import BVShimmer from '../../../../common/components/BVShimmers/BVShimmer/bv-shimmer';
import BVRefinementNav from '../../../../common/components/BVRefinementNav/bv-refinement-nav';
import BVCustomersGroupItem from './components/BVCustomersGroupItem/bv-customers-group-item';
import BVCustomersToolbar from './components/BVCustomersToolbar/bv-customers-toolbar';
import SwitchEventView from '../BVSwitchEventView/bv-switch-event-view';

interface IBVCustomersGroup {
    customers?: CustomerSummary[];
    customersLoading: boolean;
    dataFilters?: any;
    events: BookedForSalesEventSummary[];
    eventsLoading: boolean;
    showEventFilter: boolean;
    onClick: (customer: CustomerSummary) => void;
    onFilterChange: (values: any) => void;
}

const BVCustomersGroup: React.FunctionComponent<IBVCustomersGroup> = ({ customers, customersLoading, events, eventsLoading, dataFilters, showEventFilter, onClick, onFilterChange }) => {
    const [orderData, setOrderData] = useState<CustomerSummary[]>([]);

    useEffect(() => {
        customers && setOrderData(_.orderBy(customers, (entry) => entry.fullName, 'asc'));
    }, [customers]);

    return (
        <div className="bv-customers-group-container">
            <div className="switch-event-view-container">
                <SwitchEventView 
                    events={events} 
                    eventsLoading={eventsLoading} 
                />
            </div>
            <Row>
                <Col span={12}>
                    <span className="heading">{'Customers'}</span>
                </Col>
                <Col span={12} style={{ textAlign: 'right' }}>
                    <BVRefinementNav
                        dataFilter={CUSTOMERS_REFINEMENT}
                        dataFilterLoading={customersLoading}
                        dataFilterValue={dataFilters}
                        style={{ display: 'block', lineHeight: 1, margin: 0 }}
                        onChange={onFilterChange}
                    />
                </Col>
            </Row>

            <Divider />
            
            <BVShimmer loading={customersLoading} type={'shimmer-group'}>
                <BVEmpty dataSource={orderData || []} disclaimer={'No customers found for current sales agent.'}>
                    <BVCustomersToolbar
                        defaultSorting={{
                            sorting: 'asc',
                            type: 'sort-name'
                        }}
                        items={[
                            {
                                colspan: 2,
                                type: 'no-sort-draft',
                            },
                            {
                                colspan: 16,
                                type: 'sort-name',
                                action: (sorting) => setOrderData(_.orderBy(customers, (entry) => entry.fullName, sorting))
                            },
                            {
                                colspan: 6,
                                type: 'sort-sap',
                                action: (sorting) => setOrderData(_.orderBy(customers, (entry) => entry.sapCode, sorting))
                            }
                        ]}
                    />

                    <div className="bv-customers-group-item-wrapper">
                        {_.map(orderData, (dataItem, dataIndex) => (
                            <BVCustomersGroupItem 
                                key={dataIndex} 
                                customer={dataItem} 
                                onClick={onClick}
                                showEventFilter={showEventFilter}
                            />
                        ))}
                    </div>
                </BVEmpty>
            </BVShimmer>
        </div>
    );
}

export default BVCustomersGroup;